import Wavelists from './lists';

export default Wavelists;
